export const DEV = process.env.NODE_ENV === 'development'

export const BACKEND = DEV ? 'localhost:4000' : 'draw.dsimon.dev'
